import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

document.addEventListener("DOMContentLoaded", async function () {
  // Use a class or data attribute for multiple roots
  const hosts = document.querySelectorAll('.loan-quote-calc-root'); // or use [data-lqc-root]

  hosts.forEach((host) => {
    const shadowRoot = host.attachShadow({ mode: "open" });

    const fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href = "https://fonts.googleapis.com/css2?family=Montserrat&display=swap";
    shadowRoot.appendChild(fontLink);
      
      const bootstrapLink = document.createElement("link");
      bootstrapLink.rel = "stylesheet";
      bootstrapLink.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
      bootstrapLink.crossOrigin = "anonymous";
      shadowRoot.appendChild(bootstrapLink);
    
      const bootstrapVars = document.createElement("style");
      bootstrapVars.textContent = `
        :host, :root {
          --bs-blue: #0d6efd;
          --bs-indigo: #6610f2;
          --bs-purple: #6f42c1;
          --bs-pink: #d63384;
          --bs-red: #dc3545;
          --bs-orange: #fd7e14;
          --bs-yellow: #ffc107;
          --bs-green: #198754;
          --bs-teal: #20c997;
          --bs-cyan: #0dcaf0;
          --bs-black: #000;
          --bs-white: #fff;
          --bs-gray: #6c757d;
          --bs-gray-dark: #343a40;
          --bs-gray-100: #f8f9fa;
          --bs-gray-200: #e9ecef;
          --bs-gray-300: #dee2e6;
          --bs-gray-400: #ced4da;
          --bs-gray-500: #adb5bd;
          --bs-gray-600: #6c757d;
          --bs-gray-700: #495057;
          --bs-gray-800: #343a40;
          --bs-gray-900: #212529;
          --bs-primary: #0d6efd;
          --bs-secondary: #6c757d;
          --bs-success: #198754;
          --bs-info: #0dcaf0;
          --bs-warning: #ffc107;
          --bs-danger: #dc3545;
          --bs-light: #f8f9fa;
          --bs-dark: #212529;
          --bs-primary-rgb: 13, 110, 253;
          --bs-secondary-rgb: 108, 117, 125;
          --bs-success-rgb: 25, 135, 84;
          --bs-info-rgb: 13, 202, 240;
          --bs-warning-rgb: 255, 193, 7;
          --bs-danger-rgb: 220, 53, 69;
          --bs-light-rgb: 248, 249, 250;
          --bs-dark-rgb: 33, 37, 41;
          --bs-primary-text-emphasis: #052c65;
          --bs-secondary-text-emphasis: #2b2f32;
          --bs-success-text-emphasis: #0a3622;
          --bs-info-text-emphasis: #055160;
          --bs-warning-text-emphasis: #664d03;
          --bs-danger-text-emphasis: #58151c;
          --bs-light-text-emphasis: #495057;
          --bs-dark-text-emphasis: #495057;
          --bs-primary-bg-subtle: #cfe2ff;
          --bs-secondary-bg-subtle: #e2e3e5;
          --bs-success-bg-subtle: #d1e7dd;
          --bs-info-bg-subtle: #cff4fc;
          --bs-warning-bg-subtle: #fff3cd;
          --bs-danger-bg-subtle: #f8d7da;
          --bs-light-bg-subtle: #fcfcfd;
          --bs-dark-bg-subtle: #ced4da;
          --bs-primary-border-subtle: #9ec5fe;
          --bs-secondary-border-subtle: #c4c8cb;
          --bs-success-border-subtle: #a3cfbb;
          --bs-info-border-subtle: #9eeaf9;
          --bs-warning-border-subtle: #ffe69c;
          --bs-danger-border-subtle: #f1aeb5;
          --bs-light-border-subtle: #e9ecef;
          --bs-dark-border-subtle: #adb5bd;
          --bs-white-rgb: 255, 255, 255;
          --bs-black-rgb: 0, 0, 0;
          --bs-font-sans-serif: "Montserrat", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
          --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
          --bs-gradient: linear-gradient(180deg, #ffffff26, #fff0);
          --bs-body-font-family: var(--bs-font-sans-serif);
          --bs-body-font-size: 1rem;
          --bs-body-font-weight: 400;
          --bs-body-line-height: 1.5;
          --bs-body-color: #212529;
          --bs-body-color-rgb: 33, 37, 41;
          --bs-body-bg: transparent;
          --bs-body-bg-rgb: 255, 255, 255;
          --bs-emphasis-color: #000;
          --bs-emphasis-color-rgb: 0, 0, 0;
          --bs-secondary-color: #212529bf;
          --bs-secondary-color-rgb: 33, 37, 41;
          --bs-secondary-bg: #e9ecef;
          --bs-secondary-bg-rgb: 233, 236, 239;
          --bs-tertiary-color: #21252980;
          --bs-tertiary-color-rgb: 33, 37, 41;
          --bs-tertiary-bg: #f8f9fa;
          --bs-tertiary-bg-rgb: 248, 249, 250;
          --bs-heading-color: inherit;
          --bs-link-color: #0d6efd;
          --bs-link-color-rgb: 13, 110, 253;
          --bs-link-decoration: underline;
          --bs-link-hover-color: #0a58ca;
          --bs-link-hover-color-rgb: 10, 88, 202;
          --bs-code-color: #d63384;
          --bs-highlight-color: #212529;
          --bs-highlight-bg: #fff3cd;
          --bs-border-width: 1px;
          --bs-border-style: solid;
          --bs-border-color: #dee2e6;
          --bs-border-color-translucent: rgba(0, 0, 0, .175);
          --bs-border-radius: 0.375rem;
          --bs-border-radius-sm: 0.25rem;
          --bs-border-radius-lg: 0.5rem;
          --bs-border-radius-xl: 1rem;
          --bs-border-radius-xxl: 2rem;
          --bs-border-radius-2xl: var(--bs-border-radius-xxl);
          --bs-border-radius-pill: 50rem;
          --bs-box-shadow: 0 0.5rem 1rem #00000026;
          --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, .075);
          --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, .175);
          --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, .075);
          --bs-focus-ring-width: 0.25rem;
          --bs-focus-ring-opacity: 0.25;
          --bs-focus-ring-color: #0d6efd40;
          --bs-form-valid-color: #198754;
          --bs-form-valid-border-color: #198754;
          --bs-form-invalid-color: #dc3545;
          --bs-form-invalid-border-color: #dc3545;
        }
      `;
      shadowRoot.appendChild(bootstrapVars);
    
      const resetStyles = document.createElement("style");
      resetStyles.textContent = `
        *, *::before, *::after {
          box-sizing: border-box;
        }
    
        .lqc {
          margin: 0;
          padding: 0;
          font-family: var(--bs-body-font-family, system-ui, sans-serif);
          background-color: var(--bs-body-bg);
          color: var(--bs-body-color);
        }
    
        .lqc .form-control.is-invalid {
          border: 1px solid var(--bs-form-invalid-border-color);
        }

          .lqc h4 {
              margin-bottom: 20px;
          }

          .lqc .info {
              font-style: italic;
          }

          .lqc .dropdown {
              list-style: none;
              margin: 5px 0;
              padding: 5px;
              border: 1px solid #ccc;
              background: white;
              width: 100%;
              max-height: 150px;
              overflow-y: auto;
              position: absolute;
              z-index: 1000;
          }

          .lqc .dropdown li {
              padding: 8px;
              cursor: pointer;
              border-bottom: 1px solid #eee;
          }

          .lqc .dropdown li .company-number {
              font-style: italic;
              font-size: 14px;
          } 

          .lqc .dropdown li:last-child {
              border-bottom: none;
          }

          .lqc .dropdown li:hover {
              background: #f0f0f0;
          }

          .lqc .form-control {
              width: 100%;
              padding: 8px;
              font-size: 16px;
              background-color: #fff;
          }

          .lqc fieldset.form-control {
              background-color: transparent;
          }

          .lqc .confirmation-screen {
              padding: 20px;
          }

          .lqc .proceed-btn {
              background: #28a745;
              color: white;
              border: none;
              cursor: pointer;
              margin-right: 10px;
          }

          .lqc .decline-btn {
              border: none;
              cursor: pointer;
          }

          .lqc legend {
              font-size: 16px;
              font-style: italic;
              margin-bottom: 10px;
          }

          .lqc .loading-indicator {
              font-size: 12px;
              font-style: italic;
          }

          .lqc .inner-container {
              max-width: 800px;
              min-width: 200px;
          }

          .lqc .btn-primary {
              min-height: 48px;
              --bs-btn-color: #fff;
              --bs-btn-bg: rgb(8, 44, 102);
              --bs-btn-border-color: rgb(8, 44, 102);
              --bs-btn-hover-color: #fff;
              --bs-btn-hover-bg: rgb(21, 57, 115);
              --bs-btn-hover-border-color: rgb(21, 57, 115);
              --bs-btn-focus-shadow-rgb: 49, 132, 253;
              --bs-btn-active-color: #fff;
              --bs-btn-active-bg: rgb(0, 31, 89);
              --bs-btn-active-border-color: rgb(0, 31, 89);
              --bs-btn-disabled-bg: rgb(0, 31, 89);
              --bs-btn-disabled-border-color: rgb(0, 31, 89);
          }

          .lqc .form-select {
              min-height: 48px;
              border-radius: var(--bs-border-radius);
              border: 1px solid var(--bs-border-color);
              padding: 0.375rem 2.25rem 0.375rem 0.75rem;
              font-size: 1rem;
              color: var(--bs-body-color);
              background-color: #fff;
              cursor: pointer;
          }

          .lqc .form-select:focus {
              border-color: rgb(8, 44, 102);
              box-shadow: 0 0 0 0.25rem rgba(8, 44, 102, 0.25);
          }

          .lqc .lqc-form-range::-webkit-slider-thumb {
              background-color: rgb(8, 44, 102) !important;
              border: none;
          }

          .lqc .lqc-form-range::-moz-range-thumb {
              background-color: rgb(8, 44, 102) !important;
              border: none;
          }

          .lqc .lqc-form-range::-webkit-slider-runnable-track {
              background-color: #fff;
          }

          .lqc .lqc-form-range::-moz-range-track {
              background-color: #fff;
          }

          .lqc .vat-term-locked {
              background-color: #f8f9fa;
              border: 1px solid var(--bs-border-color);
              border-radius: var(--bs-border-radius);
              padding: 0.375rem 0.75rem;
              min-height: 48px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              color: #6c757d;
              user-select: none;
          }

          .lqc .vat-term-locked .locked-badge {
              background-color: #e9ecef;
              color: #6c757d;
              font-size: 12px;
              font-weight: 500;
              padding: 2px 8px;
              border-radius: 4px;
              border: 1px solid #dee2e6;
          }

          .lqc .info-tooltip-icon {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              width: 16px;
              height: 16px;
              border-radius: 50%;
              background-color: transparent;
              color: #6c757d;
              font-size: 13px;
              font-style: normal;
              cursor: help;
              margin-left: 4px;
              vertical-align: middle;
          }

          .lqc .btn-quote {
              max-width: 360px;
              font-weight: 600;
              font-size: 16px;
              letter-spacing: 0.2px;
              padding: 12px 24px;
              min-height: 52px;
          }

          .lqc .lqc-toggle-group {
              display: flex;
              gap: 8px;
              width: 100%;
          }

          .lqc .lqc-toggle-btn {
              flex: 1;
              padding: 8px 16px;
              border: 1.5px solid #dee2e6;
              background-color: #f8f9fa;
              color: #495057;
              font-size: 15px;
              font-weight: 600;
              border-radius: 6px;
              cursor: pointer;
              transition: all 0.2s ease-in-out;
              text-align: center;
              line-height: 1.5;
          }

          .lqc .lqc-toggle-btn:hover {
              background-color: rgba(8, 44, 102, 0.08);
              border-color: rgb(8, 44, 102);
              color: rgb(8, 44, 102);
          }

          .lqc .lqc-toggle-btn.active {
              background-color: rgb(8, 44, 102);
              border-color: rgb(8, 44, 102);
              color: #fff;
              box-shadow: 0 2px 6px rgba(8, 44, 102, 0.2);
          }

          .lqc .tab-header-title {
              font-size: 1.125rem;
              font-weight: 600;
              margin-bottom: 0.35rem;
              color: var(--bs-body-color);
          }

          .lqc .tab-header-subtitle {
              font-size: 0.95rem;
              font-weight: 700;
              margin-bottom: 0.75rem;
              color: var(--bs-body-color);
          }

          .lqc .tab-button-group {
              display: grid;
              grid-template-columns: repeat(4, 1fr);
              gap: 12px;
              margin-bottom: 1.75rem;
          }

          @media (max-width: 768px) {
              .lqc .tab-button-group {
                  grid-template-columns: repeat(2, 1fr);
                  gap: 8px;
              }
          }

          @media (max-width: 480px) {
              .lqc .tab-button-group {
                  grid-template-columns: 1fr;
              }
          }

          .lqc .calc-tab-btn {
              border: 1.5px solid rgb(8, 44, 102);
              background-color: #fff;
              color: rgb(8, 44, 102);
              padding: 9px 12px;
              font-size: 15px;
              font-weight: 600;
              border-radius: 4px;
              cursor: pointer;
              text-align: center;
              transition: all 0.2s ease-in-out;
              white-space: nowrap;
          }

          .lqc .calc-tab-btn:hover {
              background-color: rgba(8, 44, 102, 0.06);
          }

          .lqc .calc-tab-btn.active {
              background-color: rgb(8, 44, 102);
              color: #fff;
              border-color: rgb(8, 44, 102);
          }

          /* Stepper Styles */
          .lqc .lqc-stepper-container {
              max-width: 440px;
              margin: 0 auto 1.5rem auto;
              padding: 0.25rem 0;
          }

          .lqc .lqc-stepper {
              display: flex;
              align-items: center;
              justify-content: space-between;
          }

          .lqc .lqc-step-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 4px;
              font-size: 12px;
              font-weight: 500;
              color: #6c757d;
          }

          .lqc .lqc-step-item.active {
              color: rgb(8, 44, 102);
              font-weight: 700;
          }

          .lqc .lqc-step-item.completed {
              color: #198754;
              font-weight: 600;
          }

          .lqc .lqc-step-circle {
              width: 28px;
              height: 28px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #e9ecef;
              color: #6c757d;
              font-size: 12px;
              font-weight: 700;
              transition: all 0.2s ease-in-out;
          }

          .lqc .lqc-step-item.active .lqc-step-circle {
              background-color: rgb(8, 44, 102);
              color: #fff;
              box-shadow: 0 0 0 3px rgba(8, 44, 102, 0.2);
          }

          .lqc .lqc-step-item.completed .lqc-step-circle {
              background-color: #198754;
              color: #fff;
          }

          .lqc .lqc-step-label {
              font-size: 12px;
              letter-spacing: 0.2px;
          }

          .lqc .lqc-step-line {
              flex: 1;
              height: 2px;
              background-color: #dee2e6;
              margin: 0 8px 14px 8px;
              transition: background-color 0.2s ease-in-out;
          }

          .lqc .lqc-step-line.completed {
              background-color: #198754;
          }

          /* Step 2 Quotation Review Card */
          .lqc .lqc-quotation-card {
              background: #fff;
              border: 1px solid #dee2e6;
              border-radius: 8px;
              overflow: hidden;
              box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
              max-width: 620px;
              margin: 0 auto;
          }

          .lqc .lqc-quote-header {
              background: rgb(8, 44, 102);
              color: #fff;
              padding: 20px 24px;
              text-align: center;
          }

          .lqc .lqc-quote-header h3 {
              margin: 0;
              font-size: 1.25rem;
              font-weight: 700;
              color: #fff;
          }

          .lqc .lqc-quote-subtitle {
              margin: 4px 0 0 0;
              font-size: 0.85rem;
              opacity: 0.85;
              color: #e2e8f0;
          }

          .lqc .lqc-quote-body {
              padding: 24px;
          }

          .lqc .lqc-hero-repayment {
              background: #f8f9fa;
              border: 1.5px solid #e9ecef;
              border-radius: 8px;
              padding: 16px;
              text-align: center;
              margin-bottom: 20px;
          }

          .lqc .lqc-hero-label {
              font-size: 0.875rem;
              font-weight: 600;
              color: #6c757d;
              display: block;
              margin-bottom: 4px;
          }

          .lqc .lqc-hero-amount {
              font-size: 2rem;
              font-weight: 800;
              color: rgb(8, 44, 102);
              line-height: 1.2;
          }

          .lqc .lqc-hero-period {
              font-size: 1rem;
              font-weight: 500;
              color: #6c757d;
          }

          .lqc .lqc-balloon-tag {
              font-size: 0.8rem;
              color: #055160;
              background: #cff4fc;
              padding: 3px 10px;
              border-radius: 4px;
              display: inline-block;
              margin-top: 6px;
              font-weight: 500;
          }

          .lqc .lqc-breakdown-grid {
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 12px;
              margin-bottom: 20px;
          }

          @media (max-width: 540px) {
              .lqc .lqc-breakdown-grid {
                  grid-template-columns: 1fr;
              }
          }

          .lqc .lqc-metric-item {
              display: flex;
              align-items: center;
              gap: 12px;
              padding: 10px 14px;
              background: #fdfdfd;
              border: 1px solid #edf2f7;
              border-radius: 6px;
          }

          .lqc .lqc-metric-icon {
              width: 36px;
              height: 36px;
              border-radius: 6px;
              background: rgba(8, 44, 102, 0.08);
              color: rgb(8, 44, 102);
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
          }

          .lqc .lqc-metric-content {
              display: flex;
              flex-direction: column;
          }

          .lqc .lqc-metric-title {
              font-size: 0.75rem;
              color: #6c757d;
              font-weight: 500;
          }

          .lqc .lqc-metric-value {
              font-size: 0.95rem;
              color: #212529;
              font-weight: 700;
          }

          .lqc .lqc-email-notice {
              display: flex;
              align-items: center;
              gap: 12px;
              background: #e7f1ff;
              border: 1px solid #b6d4fe;
              color: #084298;
              padding: 10px 14px;
              border-radius: 6px;
              font-size: 0.85rem;
              margin-bottom: 20px;
          }

          .lqc .lqc-email-notice-icon {
              flex-shrink: 0;
              color: #0d6efd;
          }

          .lqc .lqc-action-buttons-row {
              display: flex;
              gap: 12px;
              justify-content: center;
          }

          @media (max-width: 480px) {
              .lqc .lqc-action-buttons-row {
                  flex-direction: column-reverse;
              }
          }

          .lqc .lqc-adjust-btn {
              flex: 1;
              padding: 10px 16px;
              font-weight: 600;
              border-color: #ced4da;
              color: #495057;
          }

          .lqc .lqc-adjust-btn:hover {
              background-color: #f8f9fa;
              border-color: #adb5bd;
              color: #212529;
          }

          .lqc .lqc-apply-btn {
              flex: 1;
              padding: 10px 16px;
              font-weight: 700;
              font-size: 1rem;
          }

          .lqc .lqc-trust-footer {
              display: flex;
              justify-content: center;
              gap: 8px;
              font-size: 0.75rem;
              color: #6c757d;
              margin-top: 14px;
              flex-wrap: wrap;
          }

          /* Step 3 Confirmation Screen */
          .lqc .lqc-confirmation-card {
              background: #fff;
              border: 1px solid #dee2e6;
              border-radius: 8px;
              padding: 28px 24px;
              max-width: 620px;
              margin: 0 auto;
              text-align: center;
              box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
          }

          .lqc .lqc-success-icon-wrap {
              display: flex;
              justify-content: center;
              margin-bottom: 14px;
          }

          .lqc .lqc-success-icon {
              width: 56px;
              height: 56px;
              border-radius: 50%;
              background: #d1e7dd;
              color: #198754;
              display: flex;
              align-items: center;
              justify-content: center;
          }

          .lqc .lqc-confirmation-title {
              font-size: 1.35rem;
              font-weight: 700;
              color: rgb(8, 44, 102);
              margin-bottom: 6px;
          }

          .lqc .lqc-confirmation-subtitle {
              font-size: 0.9rem;
              color: #6c757d;
              margin-bottom: 22px;
          }

          .lqc .lqc-roadmap-container {
              background: #f8f9fa;
              border: 1px solid #e9ecef;
              border-radius: 8px;
              padding: 20px;
              text-align: left;
              margin-bottom: 20px;
          }

          .lqc .lqc-roadmap-title {
              font-size: 1rem;
              font-weight: 700;
              color: #212529;
              margin-bottom: 16px;
              text-align: center;
          }

          .lqc .lqc-roadmap-timeline {
              display: flex;
              flex-direction: column;
              gap: 14px;
          }

          .lqc .lqc-roadmap-step {
              display: flex;
              gap: 12px;
              align-items: flex-start;
          }

          .lqc .lqc-roadmap-marker {
              width: 34px;
              height: 34px;
              border-radius: 50%;
              background: #fff;
              border: 1.5px solid rgb(8, 44, 102);
              color: rgb(8, 44, 102);
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
          }

          .lqc .lqc-roadmap-content {
              display: flex;
              flex-direction: column;
          }

          .lqc .lqc-step-heading {
              font-size: 0.9rem;
              font-weight: 700;
              color: #212529;
          }

          .lqc .lqc-step-desc {
              font-size: 0.8rem;
              color: #6c757d;
              margin: 2px 0 0 0;
              line-height: 1.4;
          }

          .lqc .lqc-support-box {
              display: flex;
              align-items: center;
              gap: 10px;
              background: #f1f3f5;
              border-radius: 6px;
              padding: 10px 14px;
              font-size: 0.85rem;
              color: #495057;
              text-align: left;
          }

          .lqc .lqc-support-icon {
              color: rgb(8, 44, 102);
              flex-shrink: 0;
          }

          .lqc .lqc-support-text {
              line-height: 1.4;
          }

          .lqc .lqc-clear-input-btn {
              position: absolute;
              right: 8px;
              top: 50%;
              transform: translateY(-50%);
              background: transparent;
              border: none;
              font-size: 18px;
              color: #adb5bd;
              cursor: pointer;
              padding: 0 4px;
              line-height: 1;
          }

          .lqc .lqc-clear-input-btn:hover {
              color: #495057;
          }
      `;
      shadowRoot.appendChild(resetStyles);

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js';
    shadowRoot.appendChild(script);

    const reactRoot = document.createElement("div");
    shadowRoot.append(reactRoot);

    const formType = host.dataset.formType || '';
    const showTabs = host.dataset.tabs === 'true' || host.dataset.tabs === '1' || formType === 'tabs';
    const defaultTab = host.dataset.defaultTab || (formType === 'tabs' ? '' : formType);

    const disableSubmission = window.lqcSettings && window.lqcSettings.disableSubmission === true;
    const supportPhone = (window.lqcSettings && window.lqcSettings.supportPhone) || '01443 800621';
    const root = ReactDOM.createRoot(reactRoot);
    root.render(
      <App
        formType={formType}
        showTabs={showTabs}
        defaultTab={defaultTab}
        disableSubmission={disableSubmission}
        supportPhone={supportPhone}
      />
    );
  });
});
